import {
	TIME_ESTIMATE_TYPE,
	ASSIGNEE_TYPE,
	PRIORITY_TYPE,
	PARENT_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type {
	AnalyticsMapping,
	AnalyticsPayload,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';

export const MOVE_TO_MENU_ID = 'actions/move-to' as const;
export const MOVE_TO_TOP_OF_BACKLOG_MENU_ID = 'actions/move-to/top-of-backlog' as const;
export const MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID = 'actions/move-to/bottom-of-backlog' as const;
export const MOVE_TO_BOARD_MENU_ID = 'actions/move-to/board' as const;
export const MOVE_TO_SEARCH_MENU_ID = 'actions/move-to/search' as const;
export const RANK_MENU_UP_ID = 'actions/move-to/rank-up' as const;
export const RANK_MENU_DOWN_ID = 'actions/move-to/rank-down' as const;

export const FLAG_MENU_ID = 'actions/flag' as const;
export const FLAG_ADD_FLAG_MENU_ID = 'actions/flag/add-flag' as const;
export const FLAG_REMOVE_FLAG_MENU_ID = 'actions/flag/remove-flag' as const;

export const COPY_ISSUE_LINK_MENU_ID = 'actions/copy-issue-link' as const;

export const COPY_ISSUE_KEY_MENU_ID = 'actions/copy-issue-key' as const;

export const HEADER_BULK_INDICATOR_MENU_ID = 'bulk-indicator' as const;

export const VIEW_IN_ISSUE_SEARCH_MENU_ID = 'actions/view-in-issue-search' as const;

export const SPLIT_ISSUE_MENU_ID = 'actions/split-issue' as const;

export const DELETE_ISSUE_MENU_ID = 'actions/delete-issue' as const;

export const CLONE_ISSUE_MENU_ID = 'actions/clone-issue' as const;

export const SEPARATOR_MENU_ID = 'separator' as const;

export const STORY_POINTS_MENU_ID = 'actions/story-point' as const;
export const STORY_POINTS_EDIT_MENU_ID = 'actions/story-point/edit' as const;

export const ORIGINAL_ESTIMATE_MENU_ID = 'actions/original-estimate' as const;
export const ORIGINAL_ESTIMATE_EDIT_MENU_ID = 'actions/original-estimate/edit' as const;

export const PARENT_MENU_ID = 'actions/parent' as const;
export const PARENT_SEARCH_MENU_ID = 'actions/parent/search' as const;

export const VERSION_MENU_ID = 'actions/version' as const;

export const PRIORITY_MENU_ID = 'actions/priority' as const;

export const ASSIGNEE_MENU_ID = 'actions/assignee' as const;
export const ASSIGNEE_SEARCH_MENU_ID = 'actions/assignee/search' as const;

export const GO_TO_BULK_EDITOR_MENU_ID = 'actions/go-to-bulk-editor' as const;

export const PLAN_ON_WHITEBOARD_MENU_ID = 'actions/plan-on-whiteboard' as const;

export const MOVE_ANALYTICS: AnalyticsPayload = {
	attributes: {
		actionGroup: 'move',
	},
};

export const UPDATE_ANALYTICS: AnalyticsPayload = {
	attributes: {
		actionGroup: 'update',
	},
};

export const ANALYTICS_MAPPING_TABLE: AnalyticsMapping = {
	[MOVE_TO_MENU_ID]: {
		actionSubjectId: 'moveToSprintDropdownItem',
		...MOVE_ANALYTICS,
	},
	[MOVE_TO_TOP_OF_BACKLOG_MENU_ID]: {
		actionSubjectId: 'moveToTopBacklogDropdownItem',
		...MOVE_ANALYTICS,
	},
	[MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID]: {
		actionSubjectId: 'moveToBottomBacklogDropdownItem',
		...MOVE_ANALYTICS,
	},
	[MOVE_TO_BOARD_MENU_ID]: {
		actionSubjectId: 'moveToBoardDropdownItem',
		...MOVE_ANALYTICS,
	},
	[FLAG_ADD_FLAG_MENU_ID]: {
		actionSubjectId: 'addFlagDropdownItem',
		...UPDATE_ANALYTICS,
	},
	[FLAG_REMOVE_FLAG_MENU_ID]: {
		actionSubjectId: 'removeFlagDropdownItem',
		...UPDATE_ANALYTICS,
	},
	[VIEW_IN_ISSUE_SEARCH_MENU_ID]: 'viewIssueSearchDropdownItem',
	[GO_TO_BULK_EDITOR_MENU_ID]: 'goToBulkEditorDropdownItem',
	[SPLIT_ISSUE_MENU_ID]: 'splitIssueDropdownItem',
	[DELETE_ISSUE_MENU_ID]: 'deleteDropdownItem',
	[CLONE_ISSUE_MENU_ID]: 'cloneIssueDropdownItem',
	[COPY_ISSUE_LINK_MENU_ID]: 'copyIssueLink',
	[COPY_ISSUE_KEY_MENU_ID]: 'copyIssueKey',
	[STORY_POINTS_EDIT_MENU_ID]: {
		actionSubjectId: 'updateEstimateDropdownItem',
		attributes: {
			...UPDATE_ANALYTICS.attributes,
			fieldKey: 'storyPointEstimate',
		},
	},
	[ORIGINAL_ESTIMATE_EDIT_MENU_ID]: {
		actionSubjectId: 'updateEstimateDropdownItem',
		attributes: {
			...UPDATE_ANALYTICS.attributes,
			fieldKey: TIME_ESTIMATE_TYPE,
		},
	},
	[ASSIGNEE_MENU_ID]: {
		actionSubjectId: 'updateAssigneeDropdownItem',
		attributes: {
			...UPDATE_ANALYTICS.attributes,
			fieldKey: ASSIGNEE_TYPE,
		},
	},
	[PRIORITY_MENU_ID]: {
		actionSubjectId: 'updatePriorityDropdownItem',
		attributes: {
			...UPDATE_ANALYTICS.attributes,
			fieldKey: PRIORITY_TYPE,
		},
	},
	[PARENT_MENU_ID]: {
		actionSubjectId: 'updateParentDropdownItem',
		attributes: {
			...UPDATE_ANALYTICS.attributes,
			fieldKey: PARENT_TYPE,
		},
	},
};

export const ESCAPE_WRAPPER_TESTID =
	'software-backlog.card-list.card.context-menu.escape-wrapper' as const;
